import { get, has } from 'lodash';

const CHALLENGES = ['specialOps', 'deception', 'surveillance', 'encryption'];

const getColumnTitles = ({ profile: { fullName } }, you, unkownNamePhrase) => ({
  colTitles: [you, fullName || unkownNamePhrase],
});

const getChallangeCell = (scoreKey, scores) => (
  get(scores, `[${scoreKey}].games[0].score`, 'No data')
);

const selectChallengeRows = (currentProfile, comparedProfile, phrases) => (
  CHALLENGES.map(challengeKey => ({
    ...phrases[challengeKey],
    cells: [
      getChallangeCell(challengeKey, currentProfile.scores),
      getChallangeCell(challengeKey, comparedProfile.scores),
    ],
  }))
);

const selectSpecialOpsVideoRow = (currentProfile, comparedProfile, phrases, specialOpsVideoUrl) => [
  {
    cells: [
      {
        type: 'video-card',
        sessionId: has(currentProfile, 'scores.specialOps.games')
          ? currentProfile.scores.specialOps.games.map(({ sessionId }) => sessionId) : [],
        specialOpsVideoUrl,
        noVideoMessage: phrases.specialOpsVideo.noVideoMessage,
        isVideoBeingProcessed: get(currentProfile, 'scores.specialOps.games[0].isVideoBeingProcessed', false),
      },
      {
        type: 'video-card',
        sessionId: has(comparedProfile, 'scores.specialOps.games')
          ? comparedProfile.scores.specialOps.games.map(({ sessionId }) => sessionId) : [],
        specialOpsVideoUrl,
        noVideoMessage: phrases.specialOpsVideo.noVideoMessage,
        isVideoBeingProcessed: get(comparedProfile, 'scores.specialOps.games[0].isVideoBeingProcessed', false),
      },
    ],
    rowTitle: phrases.specialOpsVideo.rowTitle,
    rowSubtitle: phrases.specialOpsVideo.rowSubtitle,
  },
];

const selectAttributesRows = (currentProfile, comparedProfile, phrases) => (
  Object.keys(currentProfile.attributes).map(attributeKey => ({
    rowTitle: phrases.attributes[attributeKey].title,
    cells: [
      currentProfile.attributes[attributeKey],
      comparedProfile.attributes[attributeKey],
    ],
  }))
);

const selectSpyRoleRows = (
  currentProfile,
  comparedProfile,
  phrases,
  currentProfileSpyRolePath,
) => ([
  {
    rowTitle: phrases.roleMatchRowHeading,
    cells: [currentProfile, comparedProfile].map((cell) => {
      const { archetype: { name, description, spyRolePath } } = cell;

      return ({
        description,
        type: 'role-match',
        role: name,
        path: cell === currentProfile ? currentProfileSpyRolePath : spyRolePath,
      });
    }),
  },
  {
    rowTitle: phrases.matchPercentageRowHeading,
    cells: [
      currentProfile.archetype.percentage,
      comparedProfile.archetype.percentage,
    ],
  },
]);

const selectComparisonTableData = (
  currentProfile,
  comparedProfile,
  {
    attributesPage,
    comparison: {
      you,
      attributesSection,
      challengesSection,
      spyRoleSection,
      noNameFallback,
    },
  },
  currentProfileSpyRolePath,
  specialOpsVideoPath,
) => (has(currentProfile, 'archetype.name') && has(comparedProfile, 'archetype.name') && ({
  spyRoles: {
    rows: selectSpyRoleRows(
      currentProfile,
      comparedProfile,
      spyRoleSection,
      currentProfileSpyRolePath,
    ),
    ...getColumnTitles(comparedProfile, you, noNameFallback),
  },
  challenges: {
    rows: [
      ...selectChallengeRows(
        currentProfile,
        comparedProfile,
        challengesSection,
      ),
      ...selectSpecialOpsVideoRow(
        currentProfile,
        comparedProfile,
        challengesSection,
        specialOpsVideoPath,
      ),
    ],
    ...getColumnTitles(comparedProfile, you, noNameFallback),
  },
  attributes: {
    rows: selectAttributesRows(
      currentProfile,
      comparedProfile,
      { ...attributesPage, ...attributesSection },
    ),
    ...getColumnTitles(comparedProfile, you, noNameFallback),
  },
})) || {};

export default selectComparisonTableData;
